import React, { useEffect, useState } from 'react'
import { ArrowLeftIcon, ChevronDownIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import CapsuleConfiguration from '../CapsuleConfiguration/CapsuleConfiguration'
import { formatDate } from '../../../utils/format.utils'
import { CapsuleConfiguratorProvider } from '../../../context/CapsuleConfiguratorContext'

const CreateCapsule = ({ capsule }) => {

    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-4">
                <div>
                    <h2 className="text-xl font-semibold">{capsule.name}</h2>
                    <p className="text-gray-500"> {formatDate(capsule.creationDate)}</p>
                </div>

                <div className="flex space-x-2">
                    <PlusIcon className="h-6 w-6 text-gray-500 cursor-pointer" />
                    <TrashIcon className="h-6 w-6 text-gray-500 cursor-pointer" />
                    <PencilIcon className="h-6 w-6 text-gray-500 cursor-pointer" />
                    <ChevronDownIcon className="h-6 w-6 text-gray-500 cursor-pointer" />
                </div>
            </div>
            <div className="mb-4">
                <p>1ère configuration {`${formatDate(Date.now())}`}</p>
            </div>
            <div className="border-t border-[#dedede] border-solid border-x-0 border-b-0 pt-4">
                <CapsuleConfiguratorProvider defaultCapsule={capsule}>
                    <DivideCapsuleProvider defaultCapsule={capsule}>
                        <CapsuleConfiguration />
                    </DivideCapsuleProvider>
                </CapsuleConfiguratorProvider>
            </div>
        </div>
    )
}

export default CreateCapsule
